import { useEffect, useState } from "react";

const HERO_IMAGES = [
  {
    src: "1.webp",
    alt: "QikTruck delivery services",
  },
  {
    src: "2.webp",
    alt: "QikTruck moving services",
  },
  {
    src: "3.webp",
    alt: "QikTruck furniture delivery",
  },
  {
    src: "4.webp",
    alt: "QikTruck logistics solutions",
  },
  {
    src: "5.webp",
    alt: "QikTruck transport services",
  },
];

const ROTATION_INTERVAL_MS = 3000;
const INITIAL_DELAY_MS = 3000;

const HeroImageRotator = ({ className = "img-hero" }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let intervalId;
    const delayId = setTimeout(() => {
      intervalId = setInterval(() => {
        setIndex((prev) => (prev + 1) % HERO_IMAGES.length);
      }, ROTATION_INTERVAL_MS);
    }, INITIAL_DELAY_MS);

    return () => {
      clearTimeout(delayId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  const current = HERO_IMAGES[index];

  return (
    <img
      src={"/heros/" + current.src}
      alt={current.alt}
      className={className}
      fetchpriority={index === 0 ? "high" : "auto"}
      loading={index === 0 ? "eager" : "lazy"}
      decoding={index === 0 ? "sync" : "async"}
      width={1408}
      height={768}
    />
  );
};

export default HeroImageRotator;
